import { deleteRequest, postRequest, putRequest, RequestDataType } from "services/api"
import { CreateEditSite } from "../models/sites-models"

export const postNewSite = async (data: Partial<CreateEditSite>) => await postRequest("/sites", data, RequestDataType.FormData)

export const editSite = async (data: Partial<CreateEditSite>) => await putRequest("/sites", data, RequestDataType.FormData)

export const deleteSite = async (siteId: string) => await deleteRequest("/sites", siteId)
